export const language = {
	projectsBlurb: 'Personal projects have been an extension of my education, allowing me to experiment with new technologies without the pressures of a professional environment. Through these projects, I’ve expanded my toolbox and deepened my ability to tackle complex problems.',
};
